export const LINK_MARKERS = ["View it here:", "Görüntülemek için:"];

export const extractNotificationLink = (notificationText) => {
  if (!notificationText) return null;

  for (const marker of LINK_MARKERS) {
    const markerIndex = notificationText.lastIndexOf(marker);
    if (markerIndex !== -1) {
      const link = notificationText.slice(markerIndex + marker.length).trim();
      if (link) return link;
    }
  }

  const linkMatch = notificationText.match(/(https?:\/\/\S+|\/console\/\S+)/);
  return linkMatch ? linkMatch[1] : null;
};

export const extractNotificationDisplay = (notificationText) => {
  if (!notificationText) return notificationText;
  let text = notificationText;
  for (const marker of LINK_MARKERS) {
    const idx = text.lastIndexOf(marker);
    if (idx !== -1) {
      text = text.slice(0, idx).trim().replace(/\.$/, "");
      break;
    }
  }
  return text;
};

export const TYPE_FILTER = {
  ALL: "all",
  T1: "1",
  T2: "2",
  OTHER: "other",
};

export const categoryForTypeId = (typeId, t) => {
  if (typeId === 1) return t("notification_page.notif_category_notice");
  if (typeId === 2) return t("notification_page.notif_category_error");
  return t("notification_page.notif_category_update");
};
